import { SearchIcon } from '@lokalise/louis';
import { useTheme } from '@lokalise/styled';
import type { ChangeEvent } from 'react';

import { Input } from '../components';
import { IconWrapper, Wrapper } from './styles';

type SearchProps = {
    value: string;
    onChange: (e: ChangeEvent<HTMLInputElement>) => void;
};

const Search = ({ value, onChange }: SearchProps) => {
    const theme = useTheme();

    return (
        <Wrapper>
            <IconWrapper>
                <SearchIcon color={theme.color.custom.content.secondary} />
            </IconWrapper>
            <Input value={value} onChange={onChange} search placeholder="Search for a team" />
        </Wrapper>
    );
};

export default Search;
